/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, answerError } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : STORY TITLE : STYLES --------------- ++++++++++ */
export default theme => ({
    storytitle: {
        height: '70%',
        textAlign: 'left',
        position: 'relative',
        zIndex: '3',
        '& .text': {
            height: '100%',
            fontSize: pxToEm(26),
            fontWeight: 'bold',
            lineHeight: '1.1',
            border: replacePXinStringWithEM('1px solid transparent'),
            transition: 'border-width 0.2s ease-out',
            '&.rail': {
                '&.medium': { fontSize: pxToEm(26), lineHeight: '1.15' },
                '&.small': { fontSize: pxToEm(24), lineHeight: '1.15' },
                '&.xsmall': { fontSize: pxToEm(22), lineHeight: '1.15' },
                '&.xxsmall': { fontSize: pxToEm(20), lineHeight: '1.15' },
                '&.xxxsmall': { fontSize: pxToEm(20), lineHeight: '1.15' },
            },
            '&.in-content': {
                '&.medium': { fontSize: pxToEm(32), lineHeight: '1.15' },
                '&.small': { fontSize: pxToEm(30), lineHeight: '1.15' },
                '&.xsmall': { fontSize: pxToEm(28), lineHeight: '1.15' },
                '&.xxsmall': { fontSize: pxToEm(26), lineHeight: '1.15' },
                '&.xxxsmall': { fontSize: pxToEm(26), lineHeight: '1.15' },

            },
            '& .editabletext': {
                textDecoration: 'underline'
            },
            '& .editabletext:empty': {
                textDecoration: 'none'
            }
        },

        '&.valid-false': {
            extend: answerError.text
        },
        // not supported in IE https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within
        '&:focus-within': {
            border: replacePXinStringWithEM('1px solid #fff'),
            transition: 'border-width 0.2s ease-in'
        }
    }
});
